<template>
  <div>
    <el-form
      :inline="true"
      label-width="180px"
      :disabled="applicationFinalSaved && !appHasRoom"
      v-loading="uploading"
    >
      <el-form-item :label="$t('label_attachment')">
        <el-autocomplete
          popper-class="my-autocomplete"
          v-model="documentType"
          clearable
          :fetch-suggestions="querySearchDocs"
          :placeholder="$t('search')"
          @select="handleSelectDoc"
        >
          <template slot-scope="{ item }">
            <div class="value">{{ item }}</div>
            <span
              class="linkRed"
              v-show="lang === 'el' ? neededDocsMandatory[neededDocsGr.indexOf(item)] === 1 : neededDocsMandatory[neededDocsEn.indexOf(item)] === 1"
            >
              {{ $t('hint_mandatoryfile') }}
            </span>
            <span
              class="link"
              v-show="lang === 'el' ? neededDocsMandatory[neededDocsGr.indexOf(item)] !== 1 : neededDocsMandatory[neededDocsEn.indexOf(item)] !== 1"
            >
              {{ $t('hint_mandatoryfile2') }}
            </span>
            <hr />
          </template>
        </el-autocomplete>
        <i class="el-icon-error" @click="documentType = ''"></i>
      </el-form-item>
      <el-form-item>
        <span
          ><i class="el-icon-document"></i
          ><a :href="`${BASE_URL_DATA}/documents?lang=${lang}`" target="_blank">
            {{ $t('docs_link') }}
          </a></span
        >
      </el-form-item>
      <br v-show="documentType != ''" />
      <el-form-item
        :label="$t('label_attachment2')"
        v-show="documentType != ''"
      >
        <el-upload
          class="upload-demo"
          ref="upload"
          accept=".pdf"
          :http-request="addAttachment"
          action="`${config.BASE_URL}/applications/1/attachments`"
          :auto-upload="true"
          :show-file-list="false"
        >
          <el-button slot="trigger" size="small" type="primary"
            >{{ $t('select_file') }}</el-button
          >
          <!--<el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">Μεταφόρτωση</el-button>-->
          <div
            class="el-upload__tip"
            slot="tip"
            v-html="$t('hint_attachment')"
          ></div>
        </el-upload>
      </el-form-item>
      <div>
        <el-form-item v-show="documentType != ''" label=" ">
          <span
            style="color: red"
            v-show="documentType != '' && showCalcMand === 1"
          >
            {{ $t('hint_mandatoryfile') }}
          </span>
          <span
            style="color: green"
            v-show="documentType != '' && showCalcMand === 0"
          >
            {{ $t('hint_mandatoryfile2') }}
          </span>
        </el-form-item>
        <el-form-item
          :label="$t('label_info')"
          v-show="documentType != '' && showCalcInfo !== null"
        >
          <span class="documentInformation" v-html="showCalcInfo">
            <!-- {{showCalcInfo}} -->
          </span>
        </el-form-item>
      </div>
    </el-form>
    <hr />
    <el-table
      :data="attachedDocumentsTable"
      style="width: 100%"
      v-loading="uploading"
      v-if="!uploading"
    >
      <el-table-column :label="$t('date')" width="130">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.date }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('document')">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{ $t('doc') }} : {{ lang === 'el' ? scope.row.typeGr : scope.row.typeEn }}</p>
            <p>{{ $t('comments') }} : {{ scope.row.applicantComment }}</p>
            <div slot="reference" class="name-wrapper">
              <!-- {{ $t("doc_type[doc_type.findIndex(x => x.name === calcType)].name") }} -->
              {{ calcType(scope.row.typeGr, scope.row.typeEn, scope.row.type) }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column :label="$t('filename')" width="200">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{ $t('doc') }} : {{ lang === 'el' ? scope.row.typeGr : scope.row.typeEn }}</p>
            <p>{{ $t('comments') }} : {{ scope.row.applicantComment }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium">{{ scope.row.name }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column :label="$t('actions')" width="130">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            round
            @click="downloadPdf(scope.$index, scope.row)"
            icon="el-icon-download"
            >{{ $t('download') }}</el-button
          >
          <div>
            <el-button
              size="mini"
              type="danger"
              plain="plain"
              round=""
              :disabled="disableDel(scope.$index, scope.row)"
              @click="deletePdf(scope.$index, scope.row)"
              icon="el-icon-delete"
              >{{ $t('delete') }}</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('user_comment')" class="hidden-sm-and-down">
        <template slot-scope="scope">
          <el-input
            :disabled="scope.row.precheckerChecked || applicationFinalSaved"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder=""
            v-model="scope.row.applicantComment"
            @change="commentChanged(scope.$index, scope.row)"
          >
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('doatap_comment')"
        class="hidden-sm-and-down"
        v-if="showPrecheckerComment"
      >
        <template slot-scope="scope">
          <el-input
            :disabled="true"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder=""
            v-model="scope.row.precheckerComment"
            @change="commentChanged(scope.$index, scope.row)"
          >
          </el-input>
        </template>
      </el-table-column>
    </el-table>
    <hr />
    <el-form
      :inline="true"
      label-width="160px"
      class="actApproval"
      :disabled="!applicationFinalSaved"
      v-if="showPrintApproval"
      v-loading="sendingApproval"
    >
      <div>{{ $t('draft_approval') }}</div>
      <el-form-item :label="$t('updateData')">
        <el-radio-group
          v-model="actApproval.approved"
          @change="actApprovedChanged"
          :disabled="disableActApprove"
        >
          <el-radio :label="true">{{ $t('correctInfo') }}</el-radio>
          <el-radio :label="false">{{ $t('updateInfo') }}</el-radio>
        <!-- <el-tooltip placement='right'>
            <div slot='content'>Ενημέρωση</div>
            <i class='el-icon-question'></i>
          </el-tooltip> -->
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('remarks')">
        <el-input
          class="biggest"
          type="textarea"
          maxlength="300"
          show-word-limit
          :placeholder="$t('placeholder_act')"
          v-model="actApproval.comment"
          :disabled="disableActApprove"
        >
        </el-input>
      </el-form-item>
      <el-tooltip placement="top">
        <div slot="content">{{ $t('sendApprove') }}</div>
        <el-button
          size="mini"
          type="warning"
          round=""
          @click="sendApproval"
          :disabled="disableActApprove"
          >{{ $t('sendApprove2') }}</el-button
        >
      </el-tooltip>
    </el-form>
    <el-form label-width="90px">
      <el-form-item label="" v-if="showPrecheckerComment"
        >{{ $t('prechecker_comment') }}
        <span
          v-html="
            precheckerCommentForUserTmp ? precheckerCommentForUserTmp : '---'
          "
        ></span>
      </el-form-item>
      <el-form-item label=""
        >{{ $t('applicant_comment') }}
        <el-input
          class="biggest"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 10 }"
          :placeholder="$t('overall_comment')"
          v-model="generalComment"
          @change="generalCommentChanged"
          :disabled="applicationFinalSaved"
        >
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css'
import { upload } from '../../services/file-upload.fake.service'
import * as axios from 'axios'
import config from '../../config.js'
import sharedMethods from './sharedMethods.js'
import { mapGetters } from 'vuex'

const BASE_URL = `${config.BASE_URL}/users/uid`
const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3
const decisionReceiptDocs = [20, 1008, 1010]

export default {
  props: [
    // 'language',
    'appGeneralComment',
    'attachedDocumentsTable',
    'appId',
    'applicationFinalSaved',
    'neededDocsGr',
    'neededDocsEn',
    'neededDocsIds',
    'externalUserId',
    'neededDocsInformation',
    'neededDocsInformationGr',
    'neededDocsInformationEng',
    'neededDocsMandatory',
    'precheckerCommentForUser',
    'praksiDownloadedFromUser',
    'actApproval',
    'applicationHistory'
  ],
  mixins: [sharedMethods],
  data() {
    return {
      BASE_URL_DATA: `${config.BASE_URL}`,
      sendingApproval: false,
      generalComment:
        this.appGeneralComment && this.appGeneralComment.length > 0
          ? this.appGeneralComment
          : '',
      checkedOk: false,
      uploading: false,
      documentComment: '',
      documentType: '',
      uploadError: null,
      currentStatus: null,
      fileCount: 1,
      neededDocumentsLeft: this.neededDocs(),
      mandatoryDocsUploaded: false,
    }
  },
  mounted() {
    this.reset()
    this.checkAttachments()
    this.neededDocumentsLeft = this.neededDocs()
  },
  computed: {
    lastStep() {
      return this.applicationHistory[this.applicationHistory.length - 1]
    },
    lang () {
      return this.$i18n.locale
    },
    showCalcMand () {
      return this.lang === 'el'
        ? this.neededDocsMandatory[this.neededDocsGr.indexOf(this.documentType)]
        : this.neededDocsMandatory[this.neededDocsEn.indexOf(this.documentType)]
    },
    showCalcInfo () {
      // return this.lang === 'el'
      //   ? [8, 12, 2002, 2003].includes(this.neededDocsIds[this.neededDocsGr.indexOf(this.documentType)]) 
      //     ? `${this.neededDocsInformationGr[this.neededDocsGr.indexOf(this.documentType)]}<br><a href="https://eduslim1.minedu.gov.gr/laravel/public/api/instructions?lang=el">Λίστα τίτλων από ιδιωτ. φορείς μέσω συμφωνίας δικαιόχρησης</a>`
      //     : this.neededDocsInformationGr[this.neededDocsGr.indexOf(this.documentType)]
      //   : this.neededDocsInformationEng[this.neededDocsEn.indexOf(this.documentType)]

      if(this.lang === 'el') {
        return this.neededDocsInformationGr[this.neededDocsGr.indexOf(this.documentType)]
      } else {
        return this.neededDocsInformationEng[this.neededDocsEn.indexOf(this.documentType)]
      }

    },
    disableActApprove() {
      return this.actApproval.dateApproved !== null
    },
    showPrecheckerComment() {
      let lastStep = this.applicationHistory[this.applicationHistory.length - 1]
      return (
        lastStep.applicationStatus === 'userW_' ||
        (lastStep.applicationStatus === 'precheckerW_' &&
          lastStep.judgment.pending)
      )
    },
    showPrintApproval() {
      let lastStep = this.applicationHistory[this.applicationHistory.length - 1]
      return (
        this.applicationFinalSaved &&
        lastStep.applicationStatus === 'printDecisionW_' &&
        this.attachedDocumentsTable.find(doc => doc.type === 22)
      )
    },
    precheckerCommentForUserTmp() {
      return this.precheckerCommentForUser
    },
    ...mapGetters({
      appHasRoom: 'appHasRoom',
    })
    // generalComment () {
    //   return this.appGeneralComment ? this.appGeneralComment : ''
    // },
  },
  methods: {
    sendApproval() {
      if (
        !this.actApproval.approved &&
        (this.actApproval.comment === null || this.actApproval.comment === '')
      ) {
        this.$notify.error({
          title: this.$t('fail'),
          message: this.$t('correct_approval'),
          duration: 3000,
          offset: 100,
        })
        return
      }
      // TODO deactivate button when approval send
      this.sendingApproval = true
      axios
        .put(
          `${config.BASE_URL}/externalusers/${this.externalUserId}/applications/${this.appId}/act-approval`,
          { actApproval: this.actApproval }
        )
        .then(response => {
          this.sendingApproval = false
          this.actApproval.dateApproved = Date.now()
          this.backendSuccessMsg(response)
          // this.$notify.success({
          //   title: this.$t("warning"),
          //   message: this.$t("approval"),
          //   duration: 3000,
          //   offset: 100
          // })
        })
        .catch(err => {
          this.sendingApproval = false
          // this.$notify.error({
          //   title: this.$t("fail"),
          //   message: this.$t("approval_fail"),
          //   duration: 3000,
          //   offset: 100
          // })
          this.backendErrorNotify(err)
        })
    },
    actApprovedChanged() {
      // todo
      // this.$emit('actApprovedChange', this.actApproval)
    },
    calcType(typeGr, typeEn, type) {
      if(this.lang === 'el') {
        if (typeGr === undefined && type === 20) {
          return 'ΠΡΑΞΗ ΑΝΑΓΝΩΡΙΣΗΣ'
        } else if (type === 21) {
          return 'ΕΓΓΡΑΦΑ ΑΠΟ ΠΡΟΕΛΕΓΧΟ'
        } else if (type === 22) {
          return 'ΠΡΟΣΧΕΔΙΟ ΠΡΑΞΗΣ ΑΝΑΓΝΩΡΙΣΗΣ'
        } else if (type === 1006) {
          return 'ΑΛΛΟ ΕΓΓΡΑΦΟ ΕΠΑΝΕΞΕΤΑΣΗΣ (E.E.E.)'
        } else if (type === 1014) {
          return 'ΣΥΝΟΔΕΥΤΙΚΟ ΕΓΓΡΑΦΟ ΕΙΔ. ΕΠΙΤΡ. ΕΠΑΝΕΞΕΤΑΣΗΣ'
        } else if (type === 1007) {
          return 'ΠΡΟΣΩΡΙΝΗ ΕΠΙΣΤΟΛΗ ΑΠΟΡΡΙΨΗΣ ΕΚΠΡΟΘΕΣΜΗΣ ΑΙΤΗΣΗΣ ΕΠΑΝΕΞΕΤΑΣΗΣ'
        } else if (type === 1008) {
          return 'ΕΠΙΣΤΟΛΗ ΑΠΟΡΡΙΨΗΣ ΕΚΠΡΟΘΕΣΜΗΣ ΑΙΤΗΣΗΣ ΕΠΑΝΕΞΕΤΑΣΗΣ'
        } else if (type === 1009) {
          return 'ΠΡΟΣΩΡΙΝΗ ΕΠΙΣΤΟΛΗ ΕΜΜΟΝΗΣ ΣΤΗΝ ΠΡΟΗΓΟΥΜΕΝΗ ΠΡΑΞΗ ΑΝΑΓΝΩΡΙΣΗΣ'
        } else if (type === 1010) {
          return 'ΕΠΙΣΤΟΛΗ ΕΜΜΟΝΗΣ ΣΤΗΝ ΠΡΟΗΓΟΥΜΕΝΗ ΠΡΑΞΗ ΑΝΑΓΝΩΡΙΣΗΣ'
        } else {
          return typeGr
        }
      } else {
        if (typeEn === undefined && type === 20) {
          return 'RECOGNITION ACT'
        } else if (type === 21) {
          return 'DOCUMENTS FROM PRECHECKER'
        } else if (type === 22) {
          return 'DRAFT RECOGNITION ACT'
        } else if (type === 1006) {
          return 'OTHER DOCUMENT FROM SPECIAL REEVALUATION BOARD'
        } else if (type === 1014) {
          return 'ACCOMPANYING DOCUMENT BY SPECIAL REEVALUATION BOARD'
        } else if (type === 1007) {
          return 'TEMPORARY LETTER OF REJECTION OF OVERDUE APPLICATION'
        } else if (type === 1008) {
          return 'LETTER OF REJECTION OF OVERDUE APPLICATION'
        } else if (type === 1009) {
          return 'TEMPORARY LETTER OF PERSISTANCE IN PREVIOUS DECISION'
        } else if (type === 1010) {
          return 'LETTER OF PERSISTANCE IN PREVIOUS DECISION'
        } else {
          return typeEn
        }
      }
    },
    querySearchDocs(queryString, cb) {
      if (this.appHasRoom) {
        var results = this.neededDocumentsLeft.filter(doc => doc === "ΑΛΛΟ ΕΓΓΡΑΦΟ")
      } else {
        var results = this.neededDocumentsLeft
          ? this.neededDocumentsLeft.filter(this.createFilter(queryString))
          : this.neededDocumentsLeft
        // call callback function to return suggestion objects
      }
      cb(results)
    },
    createFilter(queryString) {
      return link => {
        return link.indexOf(queryString) === 0
      }
    },
    handleSelectDoc(item) {
      this.documentType = item
    },
    checkAttachments() {
      let mandatoryDocsLeft = this.lang === 'el'
        ? this.neededDocumentsLeft.map(
            docLeft => this.neededDocsMandatory[this.neededDocsGr.indexOf(docLeft)]
          )
        : this.neededDocumentsLeft.map(
            docLeft => this.neededDocsMandatory[this.neededDocsEn.indexOf(docLeft)]
          )
      this.mandatoryDocsUploaded = !mandatoryDocsLeft.includes(1)
      this.$emit('mandatoryDocsEvent', this.mandatoryDocsUploaded)
    },
    generalCommentChanged() {
      this.$emit('generalCommentChanged', this.generalComment)
    },
    neededDocs() {
      let attachedDocTypes = []
      let tempTable = []
      if(this.lang === 'el') {
        this.attachedDocumentsTable.slice(0).forEach(doc => {
          attachedDocTypes.push(doc.typeGr)
        })
        tempTable = this.neededDocsGr.filter(
          item => !attachedDocTypes.includes(item)
        )
        attachedDocTypes.filter(docTypeGR => docTypeGR === 'ΑΛΛΟ ΕΓΓΡΑΦΟ').length < 10 &&
        !tempTable.includes('ΑΛΛΟ ΕΓΓΡΑΦΟ')
          ? tempTable.push('ΑΛΛΟ ΕΓΓΡΑΦΟ')
          : console.log('No type 17 or Error: more than 10 of type 17 detected')
      }
      if(this.lang === 'en') {
        this.attachedDocumentsTable.slice(0).forEach(doc => {
          attachedDocTypes.push(doc.typeEn)
        })
        tempTable = this.neededDocsEn.filter(
          item => !attachedDocTypes.includes(item)
        )
        attachedDocTypes.filter(docTypeEN => docTypeEN === 'OTHER DOCUMENT').length < 10 &&
        !tempTable.includes('OTHER DOCUMENT')
          ? tempTable.push('OTHER DOCUMENT')
          : console.log('No type 17 or Error: more than 10 of type 17 detected')
      }
      return tempTable
    },
    commentChanged(index, row) {
      this.$emit('documentsChanged', this.attachedDocumentsTable)
    },
    disableDel(index, row) {
      if (row.precheckerChecked) return true
      else if (this.applicationFinalSaved) {
        if (this.appHasRoom) {
          if (row.type !== 17) return true
          // else if (Date.parse(this.lastStep.date) > Date.parse(row.date)) return false
          else return false
        } else {
          return true
        }
      }
    },
    deletePdf(index, row) {
      this.uploading = true
      axios
        .delete(
          `${BASE_URL}/applications/${this.appId}/attachments/${row.id}`
        )
        .then(response => {
          if (response.data.success) {
            this.uploading = false
            this.backendSuccessMsg(response)
            this.attachedDocumentsTable.splice(index, 1)
            this.$emit(
              'attachedDocumentsTableChanged',
              this.attachedDocumentsTable
            )
            this.neededDocumentsLeft = this.neededDocs()
            this.checkAttachments()
          } else {
            this.uploading = false
            this.checkAttachments()
            this.$notify.warning({
              title: this.$t('warning'),
              message: this.$t('fail_delete'),
              offset: 100,
            })
          }
        })
        .catch(err => {
          this.backendErrorNotify(err)
          this.uploading = false
          // this.$notify.error({
          //   title: this.$t("fail"),
          //   message: this.$t("fail_delete"),
          //   offset: 100
          // })
        })
    },
    b64toBinary(b64Data) {
      let sliceSize = 512

      var byteCharacters = atob(b64Data)
      var byteArrays = []

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      return byteArrays
    },
    pdfGet(rowid, fname) {
      axios
        .get(
          `${BASE_URL}/applications/${this.appId}/attachments/${rowid}`
        )
        .then(response => {
          // pdfWindow.document.write('<p>Done</p>')
          // pdfWindow.document.write("<encode width='100%' height='100%' src='data:application/pdf;base64, " +
          //   encodeURI(response.data.data.file[0]) + "'></iframe>")
          var a = document.createElement('a')
          document.body.appendChild(a)
          // for IE we need a.setAttribute('style', 'display: none') and
          // navigator.msSaveBlob(blob, fname)
          // a.style = 'display: none' // break in strict IE
          a.setAttribute('style', 'display: none')
          let blob = new Blob(this.b64toBinary(response.data.data.file[0]), {
            type: 'octet/stream',
          })
          let url = window.URL.createObjectURL(blob)
          // a.href = url
          a.setAttribute('href', url)
          // a.download = fname
          a.setAttribute('download', fname)
          if (window.navigator && window.navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, fname)
          }
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch(err => {
          this.backendErrorNotify(err)
        })
    },
    downloadPdf0(index, row) {
      let filename = `Αρχείο (${row.name}).pdf`
      if (row.type === 20 && this.praksiDownloadedFromUser === -100) {
        this.$confirm(this.$t('first_download'), this.$t('warning'), {
          confirmButtonText: 'OK',
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
        }).then(() => {
          // let pdfWindow = window.open('')
          // pdfWindow.document.write(`<p>Downloading ${row.type} with name ${row.name}...</p>`)
          this.pdfGet(row.id, filename)
        })
      } else if (
        row.type === 20 &&
        this.praksiDownloadedFromUser >= 0 &&
        this.praksiDownloadedFromUser <= 10
      ) {
        this.$confirm(
          this.praksiDownloadedFromUser + this.$t('remaining'),
          this.$t('warning'),
          {
            confirmButtonText: 'OK',
            cancelButtonText: this.$t('cancel'),
            type: 'warning',
          }
        ).then(() => {
          // let pdfWindow = window.open('')
          // pdfWindow.document.write(`<p>Downloading ${row.type} with name ${row.name}...</p>`)
          this.pdfGet(row.id, filename)
        })
      } else if (row.type === 20 && this.praksiDownloadedFromUser >= 11) {
        this.$confirm(
          this.$t('received') +
            this.praksiDownloadedFromUser +
            this.$t('daysbefore'),
          this.$t('warning'),
          {
            confirmButtonText: 'OK',
            cancelButtonText: this.$t('cancel'),
            type: 'warning',
          }
        ).then(() => {
          // let pdfWindow = window.open('')
          // pdfWindow.document.write(`<p>Downloading ${row.type} with name ${row.name}...</p>`)
          this.pdfGet(row.id, filename)
        })
      } else {
        this.pdfGet(row.id, filename)
      }
    },
    downloadPdf(index, row) {
      let filename = `Αρχείο (${row.name}).pdf`
      console.log('Downloaded by user at:', row.downloadedByUserAt)
      if (decisionReceiptDocs.includes(row.type) && !row.downloadedByUserAt) {
        this.$confirm(this.$t('first_download2'), this.$t('warning'), {
          confirmButtonText: 'OK',
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
        }).then(() => {
          this.pdfGet(row.id, filename)
          console.log('Decision downloaded')
          row.downloadedByUserAt = Date.now()
        })
      } else {
        this.pdfGet(row.id, filename)
      }
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      this.uploadError = null
    },
    formatTimestamp(timestamp) {
      const date = timestamp.split('T')[0]
      const [year, month, day] = date.split('-')
      if (!year || !month || !day) {
        return '---'
      }
      return `${day}-${month}-${year}`
    },
    addAttachment(file) {
      this.uploading = true
      this.currentStatus = STATUS_SAVING
      if (file.file.size < 13000000) {
        upload(file.file, this.documentType)
          .then(file => {
            // move them inside the post
            let index = this.lang === 'el'
              ? this.neededDocsGr.indexOf(file.type)
              : this.neededDocsEn.indexOf(file.type)
            // Take the timestamp of the post response for the date in newDoc
            let newDoc = {
              type: this.neededDocsIds[index],
              name: file.name,
              date: '',
              applicantComment: '',
              file: file.file,
            }
            this.lang === 'el' ? newDoc.typeGr = file.type : newDoc.typeEn = file.type
            const url = `${BASE_URL}/applications/${this.appId}/attachments`
            return axios
              .post(
                url,
                {
                  type: this.neededDocsIds[index],
                  file: file.file,
                  name: file.name,
                  uuid: this.externalUserId,
                }
              )
              .then(response => {
                this.uploading = false
                this.currentStatus = STATUS_SUCCESS
                newDoc.date = this.formatTimestamp(response.data.timestamp)
                newDoc.id = response.data.data.id
                this.attachedDocumentsTable.push(newDoc)
                this.$emit(
                  'attachedDocumentsTableChanged',
                  this.attachedDocumentsTable
                )
                this.neededDocumentsLeft = this.neededDocs()
                this.checkAttachments()
                // this.neededDocsGr.splice(index, 1)
                this.documentType = ''
                // to be used for sync with server
                // axios.get(
                //   'https://eduslim1.minedu.gov.gr/laravel/public/api/users/uid/applications/' + this.appId)
                //   .then((response) => {
                //     this.neededDocumentsLeft = this.neededDocs()
                //   })
                this.backendSuccessMsg(response)
              })
              .catch(err => {
                console.log(err)
                this.uploadError = err.response
                this.currentStatus = STATUS_FAILED
                this.uploading = false
                this.backendErrorNotify(err)
                // this.$notify.warning({
                //   title: this.$("warning"),
                //   message: this.$t("upload_fail"),
                //   offset: 100
                // })
              })
          })
          .catch(err => {
            console.log(err)
            this.uploadError = err.response
            this.currentStatus = STATUS_FAILED
            this.uploading = false
            this.$notify.warning({
              title: this.$t('warning'),
              message: err.response.data.message,
              offset: 100,
            })
          })
      } else {
        this.uploading = false
        this.currentStatus = STATUS_FAILED
        this.$notify.warning({
          title: this.$t('warning'),
          message: this.$t('filesize'),
          offset: 100,
        })
      }
    },
    submitUpload() {
      this.$refs.upload.submit()
    },
  },
  watch: {
    lang: function(newData, oldData) {
      this.neededDocumentsLeft = this.neededDocs()
    },
    appId: function(newData, oldData) {
      this.neededDocumentsLeft = this.neededDocs()
      this.generalComment =
        this.appGeneralComment.length > 0 ? this.appGeneralComment : ''
      this.mandatoryDocsUploaded = this.checkAttachments()
      this.uploading = true
      // tosee
      setTimeout(() => {
        this.uploading = false
      }, 1000)
      // to be used for sync with server
      // axios.get(
      //   'https://eduslim1.minedu.gov.gr/laravel/public/api/users/uid/applications/' + newData)
      //   .then((response) => {
      //     console.log(response.data.attachedDocuments)
      //   })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';

.my-autocomplete {
  li {
    line-height: normal;
    padding: 3px;

    .value {
      text-overflow: clip;
      font-size: 12px;
      overflow: hidden;
      color: #6d728b;
      white-space: normal;
    }
    .linkRed {
      text-overflow: clip;
      font-size: 10px;
      color: red;
      white-space: normal;
    }
    .link {
      text-overflow: clip;
      font-size: 10px;
      color: #33408a;
      white-space: normal;
    }
  }
}
.actApproval {
  border: 5px solid #c61717;
  padding: 15px;
}
.el-form--inline {
  &.el-form-item__content {
    line-height: normal;
  }
}
.documentInformation {
  font-size: 12px;
  line-height: normal;
  color: rgb(92, 116, 170);
  padding: 10px;
  color: rgb(97, 124, 152);
  background-color: rgb(179, 192, 209);
  width: 400px;
  border-radius: 15px 30px;
  border: 2px solid #7fa3bb;
  display: -webkit-box;
  display: -ms-flexbox;
  display: block;
}
.biggest {
  &.el-textarea {
    width: 530px;
  }
}
.el-table__body,
.el-table__footer,
.el-table__header {
  table-layout: auto;
}
.el-select {
  &.biggest {
    width: 600px;
  }
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 140px;
  position: absolute;
  cursor: pointer;
}
.el-autocomplete {
  width: 440px;
}
@media only screen and (max-width: $screen-sm-min) {
  .el-autocomplete {
    width: 240px;
  }
  .biggest {
    &.el-textarea {
      width: 240px;
    }
  }
  .documentInformation {
    width: 240px;
  }
}
// .el-table td, .el-table th {
//   padding: 0px;
// }
</style>
